<template>
  <div>

    <div id="card-payment-methods" class="card border-0 shadow-sm mt-3 mb-3">
      <div class="card-header bg-white">

        <button type="button" class="btn btn-outline-primary mr-2 mb-3 mb-md-0" @click.prevent="promptCreditNotes">
          <i class="fas fa-receipt mr-1"></i>
          Add Credit Notes
        </button>

        <button type="button" class="btn btn-outline-primary mr-2 mb-3 mb-md-0" @click.prevent="promptGiftVouchers">
          <i class="fas fa-gift mr-1"></i> Add Gift Vouchers
        </button>

        <template v-if="cart.payment_method">
          <!--<h6 class="modal-title font-weight-normal d-inline-block mr-2">Payment Method:</h6>-->
          <button v-if="!payment_method_groups" class="btn btn-outline-primary mr-2" @click.prevent="fetchPaymentMethods" :disabled="$parent.fetching_payment_methods">
            <i class="fas fa-circle-notch fa-spin" v-if="$parent.fetching_payment_methods"></i>
            <i class="far fa-money-bill-alt mr-1" v-if="!$parent.fetching_payment_methods"></i>
            Change Payment Method
          </button>
          <h5 class="modal-title d-inline-block">
            {{ cart.payment_method.name }}
            <span v-if="cart.payment_method.provider" class="small text-muted">By {{ cart.payment_method.provider }}</span>
          </h5>
        </template>

        <template v-else-if="!cart.payment_method">
          <!--<h5 v-if="payment_method_groups" class="modal-title d-inline-block mr-2">Payment Method</h5>-->
          <button v-if="!payment_method_groups" class="btn btn-primary" @click.prevent="fetchPaymentMethods" :disabled="$parent.fetching_payment_methods">
            <i class="fas fa-circle-notch fa-spin mr-1" v-if="$parent.fetching_payment_methods"></i>
            <i class="far fa-money-bill-alt mr-1" v-if="!$parent.fetching_payment_methods"></i> Show Payment Methods
          </button>
        </template>

      </div>
      <div v-if="payment_method_groups" class="card-body p-0">

        <div class="row">
          <div class="col-5 col-md-3" id="payment-method-sources">
            <div class="py-4 d-inline-block">
              <div class="small text-muted text-center text-uppercase mb-2">Source</div>
              <button type="button" :class="'btn btn-block mb-2 ' + (selected_source==='point_of_sale' ? 'btn-light' : 'btn-secondary')" @click.prevent="selected_source='point_of_sale'">Point of Sale</button>
              <button type="button" :class="'btn btn-block mb-2 ' + (selected_source==='website' ? 'btn-light' : 'btn-secondary')" @click.prevent="selected_source='website'">Website</button>
            </div>
          </div>
          <div class="col-7 col-md-9 py-4" id="payment-methods">
            <div v-if="payment_method_groups" v-for="(payment_method_group,group_k) in payment_method_groups" :key="group_k" class="mb-3">
              <h6>{{ payment_method_group.group_name }}</h6>
              <div v-for="(payment_method,k) in payment_method_group.methods" :key="k" v-if="selected_source===payment_method.source" class="d-inline-block mb-2 mr-2">
                <button type="button" :class="'btn btn-outline-primary ' + (cart.payment_method && cart.payment_method.id === payment_method.id ? 'active' : '')" @click.prevent="updatePaymentMethod(payment_method)" :disabled="processing">
                  <i class="fas fa-circle-notch fa-spin" v-if="processing"></i>
                  {{ payment_method.name }}
                  <template v-if="payment_method.provider">
                    <br><span :class="(!cart.payment_method || cart.payment_method.id !== payment_method.id ? 'text-muted' : '')">By {{ payment_method.provider }}</span>
                  </template>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!--<div class="row">
          <div class="col-3">
            <div class="nav flex-column nav-pills" id="payment-method-sources-tab" role="tablist" aria-orientation="vertical">
              <a :class="'nav-link ' + (selected_source==='point_of_sale' ? 'active' : '')" id="payment-method-sources-pos-tab" data-toggle="pill" href="#payment-method-sources-pos" role="tab" aria-controls="payment-method-sources-pos" aria-selected="false">Point of Sale</a>
              <a :class="'nav-link ' + (selected_source==='website' ? 'active' : '')" id="payment-method-sources-website-tab" data-toggle="pill" href="#payment-method-sources-website" role="tab" aria-controls="payment-method-sources-website" aria-selected="false">Website</a>
            </div>
          </div>
          <div class="col-9">
            <div class="tab-content" id="payment-method-sources-tabContent">
              <div :class="'tab-pane fade ' + (selected_source==='point_of_sale' ? 'show active' : '')" id="payment-method-sources-pos" role="tabpanel" aria-labelledby="payment-method-sources-pos-tab">POS</div>
              <div :class="'tab-pane fade ' + (selected_source==='website' ? 'show active' : '')" id="payment-method-sources-website" role="tabpanel" aria-labelledby="payment-method-sources-website-tab">Website</div>
            </div>
          </div>
        </div>-->

        <!--<div v-if="payment_method_groups" v-for="(payment_method_group,group_k) in payment_method_groups" :key="group_k" class="mb-3">
          <h6>{{ payment_method_group.group_name }}</h6>
          <div v-for="(payment_method,k) in payment_method_group.methods" :key="k" class="d-inline-block mb-2 mr-2">
            <button type="button" :class="'btn btn-outline-primary ' + (selected_payment_method===payment_method ? 'active' : '')" @click.prevent="updatePaymentMethod(payment_method)" :disabled="processing">
              <i class="fas fa-circle-notch fa-spin" v-if="processing"></i>
              {{ payment_method.name }}
            </button>
          </div>
        </div>-->

        <!--<div v-if="payment_method_groups" v-for="(payment_method_group,group_k) in payment_method_groups" :key="group_k" class="mb-3">
          <h6>{{ payment_method_group.group_name }}</h6>
          <div v-for="(payment_method,k) in payment_method_group.methods" :key="k" class="custom-control custom-radio mb-2">
            <input type="radio" class="custom-control-input" name="payment_method" :id="'input-payment_method-' + payment_method.id" :value="payment_method" v-model="selected_payment_method" @change="updatePaymentMethod">
            <label class="custom-control-label" :for="'input-payment_method-' + payment_method.id">{{ payment_method.name }}</label>
            <template v-if="payment_method.description">
              <br><span class="text-muted">{{ payment_method.description }}</span>
            </template>
          </div>
        </div>-->

      </div>
    </div>

  </div>
</template>

<script>
import jQuery from 'jquery'
import axios from 'axios'

export default {
  name: 'SalePaymentMethods',
  props: [
    'cart',
    'payment_method_groups'
  ],
  data: function () {
    return {
      fetching: false,
      processing: false,

      selected_source: this.cart.payment_method && this.cart.payment_method.source ? this.cart.payment_method.source : 'point_of_sale'
    }
  },
  methods: {
    promptCreditNotes () {
      jQuery('#modal-add-credit-notes').modal('show').on('shown.bs.modal', function () {
        jQuery(this).find('input').focus()
      })
    },

    promptGiftVouchers () {
      jQuery('#modal-add-gift-vouchers').modal('show').on('shown.bs.modal', function () {
        jQuery(this).find('input').focus()
      })
    },

    fetchPaymentMethods () {
      this.$parent.fetchPaymentMethods()
    },

    updatePaymentMethod (paymentMethod) {
      this.processing = true

      axios.put('/cart/' + this.cart.id + '/payment_methods', {
        id: paymentMethod.id,
        include_cart: true
      }).then((response) => {
        this.$parent.cart = response.data.data.cart

        setTimeout(() => {
          this.$parent.setPaneHeights()
        }, 100)
      }).catch(error => {
        this.$toast.error('Failed to update the payment method. ' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        this.processing = false
      })
    }
  }
}
</script>

<style scoped>
#payment-method-sources > div {
  width: 100%;
  height: 100%;
  background-color: #e9edf1;
}
#payment-method-sources .btn {
  border-radius: 0;
  border: 0;
}
#payment-method-sources .btn-light {
  background-color: #fff;
}
#payment-method-sources .btn-secondary {
  color: #212529;
  background-color: #e9edf1;
}
#payment-methods .btn {
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/sale/partials/PaymentMethods.vue